import { Redirect, Route, Switch } from "react-router-dom";

import {
  routeHelperPayrollRunsDashboard,
  routeHelperPayrollRunsDetails,
  routeHelperPayrollRunsPaystub
} from "./paths";
import { RoutePayrollRunsDashboard } from "./routes/RoutePayrollRunsDashboard";
import { RoutePayrollRunsDetails } from "./routes/RoutePayrollRunsDetails";
import { RoutePayrollRunsPaystub } from "./routes/RoutePayrollRunsPaystub";
import { getDefaultPayrollRunYear } from "./utils";

export const PayrollRunsIndex: React.FC = () => {
  return (
    <Switch>
      <Route
        component={RoutePayrollRunsPaystub}
        path={routeHelperPayrollRunsPaystub.path}
      />
      <Route
        component={RoutePayrollRunsDetails}
        path={routeHelperPayrollRunsDetails.path}
      />
      <Route
        component={RoutePayrollRunsDashboard}
        path={routeHelperPayrollRunsDashboard.path}
      />

      <Redirect
        from="*"
        to={routeHelperPayrollRunsDashboard.createLocationObject({
          year: getDefaultPayrollRunYear()
        })}
      />
    </Switch>
  );
};
